import { render, staticRenderFns } from "./indica-description.vue?vue&type=template&id=3455831a&scoped=true&"
import script from "./indica-description.vue?vue&type=script&lang=js&"
export * from "./indica-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455831a",
  null
  
)

export default component.exports